// This function is called to format the date data in Ag-Grid.
// The return value replaces the raw date data from the database.
export const dateFormatter = (props) => {
  const { value } = props;
  const now = new Date(value);
  return now.toLocaleString("en-US");
};
